import { datadogLogs } from "@datadog/browser-logs";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { ErrorBoundaryProps } from "./ErrorBoundaryProps";
import ExternalLinkSvg from "components/icons/24/actions/action-external-link.svg";
import ErrorLayout from "./ErrorLayout";
import ErrorIndicator from "./ErrorIndicator";
import Button from "components/elements/Button/Button";
import Link from "next/link";

export default function Generic404Error({ onReset }: ErrorBoundaryProps) {
  const router = useRouter();

  useEffect(() => {
    datadogLogs.logger.warn("The user visited a route that doesn't exist.");
  }, []);

  async function onClickReturn() {
    await router.push("/");
    onReset?.();
  }

  return (
    <ErrorLayout>
      <div className="inline-block rounded bg-neutral-200 px-6 py-3 font-thin text-neutral-500">
        Error code 404
      </div>
      <h1 className="flex items-center text-6xl font-thin text-primary">
        <ErrorIndicator />
        Page unavailable.
      </h1>
      <p className="text-lg font-thin text-primary">
        The link you followed may be broken, or the page may have been removed.
      </p>
      <div className="flex items-center space-x-10">
        <Button type="button" theme="primary-solid" onClick={onClickReturn}>
          Return to Keyframe
        </Button>
        <Link
          className="flex items-center gap-2 p-3"
          href="https://keyframeai.atlassian.net/servicedesk/customer/portal/9/group/21/create/72"
          target="blank"
        >
          <ExternalLinkSvg className="w-6" /> Report issue
        </Link>
      </div>
    </ErrorLayout>
  );
}
